import Http from './index';
import { serialize } from '@/util'

export const advice = (params) => Http.get(`/advice${serialize(params)}&limit=50`)
export const allAdvices = (params) => Http.get(`/advice${serialize(params)}&limit=1`)
export const postAdvice = (params = '') => Http.post(`/profile/${params.id}/advice`, params.form)
export const putAdvice = (params = '') => Http.put(`/profile/${params.id}/advice`, params.form)
